module.exports = __webpack_public_path__ + "static/media/caleta.a9906a24.jpeg";